export const queryNewsList = `/api/unoauth/article/listArticlePage`; // 新闻列表
export const newsDetail = `/api/unoauth/laboratory/getArticle`; // 新闻列表
